var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayDiscountTitle ||
    _vm.displayOdrTitle ||
    _vm.displayMobileBonusRecoveryText
    ? _c(
        "div",
        { staticClass: "bg-greige px-1 advantage-bloc-padding fw-bold small" },
        [
          _c("div", { staticClass: "py-0" }, [
            _vm._v("\n        " + _vm._s(_vm.displayDiscountTitle) + "\n    "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "py-0" }, [
            _vm._v("\n        " + _vm._s(_vm.displayOdrTitle) + "\n    "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "py-0" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.displayMobileBonusRecoveryText) +
                "\n    "
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }